import React from 'react';

//hooks
import UseMainMenuScreen from './MainMenu.hooks';

//components
import MainMenuTable from  '@/components/elements/lists/MainMenuTable';
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton';
import WidgetPanelList from  '@/components/page/widgetsPanel/WidgetPanelListScreen';
import NotificationBar from  '@/components/elements/languages/NotificationBar';
import DownloadReportButton from  '@/components/elements/global/reports/DownloadReportButton';

// utils and constants
import {AddNewContentButtonContent } from  '@/components/elements/lists/ListConstants';

import '../../../../css/lists/mainmenulist.scss';



const MainMenu = () => {
    const {hasEditorRights, widgetPanelOpen, setWidgetPanelOpen, notificationDetails, downloadContentReportUrl, isCombinedFeedEnabled} = UseMainMenuScreen();

    return (<>   
        <div className='main-menu-content-container'>
            <div className='main-menu-title-wrapper'>
                <div className='title-button'>
                    <h1 className='main-menu-title'>Menu</h1>

                    <DownloadReportButton downloadLink={downloadContentReportUrl} tooltipText="Download Content Report"/>
                </div>
                
                {hasEditorRights && <BasicButton content={<AddNewContentButtonContent isOpen={widgetPanelOpen}/>} ariaLabel={widgetPanelOpen ? 'Close widget panel' : 'Add New Content'} onButtonClick={() =>  setWidgetPanelOpen(!widgetPanelOpen)} className='add-new-content-button'/>
                    // :   <div className='table-filters'> <ViewToggleDropdown viewOption={viewOption} setViewOption={setViewOption} buttonContent={<ViewOptionButtonPlaceHolder viewOption={viewOption}/>} buttonAriaLabel={viewOptionAriaLabel(viewOption)} /></div>
                }
            </div>
            
            <WidgetPanelList className={widgetPanelOpen? 'widget-panel-is-open' : 'widget-panel-is-closed'} isCombinedFeedEnabled={isCombinedFeedEnabled} isMainMenu/>

            <MainMenuTable />
        </div>

        <NotificationBar show={notificationDetails.show} notificationStatus={notificationDetails.status} msg={notificationDetails.message} />
    </>)
}

export default MainMenu